/* eslint-disable */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";

export default function DeleteConfirmationInsideEdit({ 
  open, 
  onClose,
  permanentdeleteeditnode,
  setpermanentdeleteeditnode,
  onSave 
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Delete Confirmation</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to delete this node?
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={permanentdeleteeditnode}
              onChange={(e) => setpermanentdeleteeditnode(e.target.checked)}
              color="error"
            />
          }
          label="Delete node permanently (cannot be undone)"
        />
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, ml: 4 }}>
          If unchecked, the node will only be removed from the canvas
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          color="error"
        >
          Delete Node
        </Button>
      </DialogActions>
    </Dialog>
  );
}